<div class="menucategory">
  <span class="menucategory__label">{{ label }}</span>
</div>
